import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import InputGroup from '../../../../../components/global/InputGroup';
import { getAsset } from '../../../../../util/assets';
import Button from '../../../../../components/global/Button';
import Spinner from '../../../../../components/global/Spinner';

const propTypes = {
  values: PropTypes.shape({
    email: PropTypes.string,
    password: PropTypes.string,
    phone_number: PropTypes.string,
    code: PropTypes.string,
  }).isRequired,
  handleSubmit: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  onLoginViaPhone: PropTypes.func,
};

const EmailPasswordForm = ({
  values,
  handleSubmit,
  handleChange,
  loading,
  onLoginViaPhone,
}) => {
  return (
    <Fragment>
      <h4 className="text-center mb-4">
        Enter your email address below and I&apos;ll <br />
        send you all the photos you&apos;re in!
      </h4>
      <form
        className="w-100 px-0 px-md-6 d-flex flex-column align-items-center"
        onSubmit={handleSubmit}
      >
        <InputGroup
          id="email"
          type="email"
          name="email"
          addon={<img alt="" src={getAsset('/shutterbug/icons/email.svg')} />}
          placeholder="Your email address"
          value={values.email}
          onChange={handleChange}
          wrapperClassName="w-100 mb-2"
        />
        <Button
          type="submit"
          className="btn-block mt-2"
          disabled={loading || values.email === ''}
        >
          {loading ? <Spinner light size="xs" /> : 'Continue'}
        </Button>
        <Button
          btnStyle="link"
          className="text-extra-bold mt-2"
          onClick={() => onLoginViaPhone()}
        >
          Login via phone
        </Button>
      </form>
    </Fragment>
  );
};

EmailPasswordForm.propTypes = propTypes;

export default EmailPasswordForm;
